import React from 'react';
import BagFeeBalanceIcon from "../../../icons/BagFeeBalanceIcon";
import {IconSize} from "../../../services/IconConstants";
import Container from "../../../components/Container";
import Spinner from "../../../components/Spinner";

interface Props {
    balance?: number
}

const YourBalance = ({balance}: Props) => {

    return (
        <Container>
            <p className={'subheading'}>Your Balance</p>

            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <div style={{ width: '50%' }}>
                    <BagFeeBalanceIcon size={IconSize.bagXl} />
                </div>
                <div>
                    {Number.isInteger(balance) && <>
                        <span style={{ fontSize: '3em',fontWeight: 'bold' }}>{balance}</span> <span>bags</span>
                    </>}
                    {balance === undefined && <Spinner onBackground />}
                </div>
            </div>
        </Container>
    )
}

export default YourBalance;